import { EnvironmentProviders } from '@angular/core';
import { selectDataSources } from './data-source';
import { REAL_DATA_SOURCES } from './data-sources';

/**
 * Providers de datos para los builds de producción y stage: solo implementaciones reales.
 * El build `development` reemplaza este archivo por `data-source.providers.development.ts`
 * (ver `fileReplacements` en `angular.json`), de modo que los mocks no entran al bundle de producción.
 */
export function provideDataSources(): EnvironmentProviders {
  return selectDataSources(false, REAL_DATA_SOURCES, []);
}
